const getAPIUrl = async () => {
  // Detectar si estamos en Electron
  const isElectron = typeof process !== 'undefined' && process.type === 'renderer'

  if (isElectron) {
    // En Electron, no intentar leer connWeb.json ya que se maneja desde background.js
    // Retornar null o un valor por defecto para que el componente maneje la lógica
    return null
  }

  const request = await fetch('/static/connWeb.json')
  const response = await request.json()
  // si el environtment es development devuelvo hardcodeada la url de la API
  if (process.env.NODE_ENV === 'development') return `${process.env.VUE_APP_URL}`
  // si existe una url predeterminada uso esa
  if (response.url) return response.url
  // si no siempre retorna la url basada en el protocolo y puerto del archivo de configuración
  else return `${response.protocol}://${window.location.hostname}:${response.port}`
}

export default getAPIUrl
